module.exports = __webpack_public_path__ + "static/media/brazil.173c68f2.svg";